// Event Info: wesite-variant-change notifies the change of the variant
// current event data: id, price, compare_at_price
// find in function emitCustomEvent

document.addEventListener("DOMContentLoaded", function () {

  if (!window.wesite) return;
  if(Object.keys(window.wesite.appData.variants.data).length === 0) return;

  
  const modelle = window.wesite.appData.variants.data.modelle;

  if (modelle.length === 0) return;

  let selectedOptions = [];
  let selectedVariant = null;
  let weSelectedOption = "option1";
  const generalOptionsSyncTarget = "general-controls";
  const floatedOptionsSyncTarget = "floated-controls";
  const mainProductMap = window.wesite.appData.variants.data.mainProductMap;
  const mainProductReverseMap =
    window.wesite.appData.variants.data.mainProductReverseMap;
  
  sortModelle(modelle);
  let option1 = getOption("option1");
  let option2 = getOption("option2");
  let option3 = getOption("option3");
  // sortOption(option1);
  // sortOption(option2);
  // sortOption(option3);

  const urlHasVariant = checkURL();

  let enterPageWithBackForwardButton = false;


  try{
    const entries = performance.getEntriesByType("navigation");
    if (entries.length > 0) {
      const entry = entries[0];
      if(entry.type === "back_forward") {
        enterPageWithBackForwardButton = true;
      }
    }
  }catch(error){
    console.error("PerformanceNavigationTiming API not supported.", e);
  }
  
  async function main() {
    // initFloatedFormListeners();
    initSelectedOptions();
    if (urlHasVariant) {
      changeSelectedOptionsByVariantUrl();
    }
    setSelectedVariant();
    addLinePropertyToForm();
    if(enterPageWithBackForwardButton) {
      await sleep(250);
    }
    renderOptions(".we-custom-options", generalOptionsSyncTarget);
    hideUnavailableOptions(`.we-custom-options .${generalOptionsSyncTarget}`);

    optionsListeners(
      ".we-custom-options .select__select",
      floatedOptionsSyncTarget
    );
    if (urlHasVariant) {
      syncData(generalOptionsSyncTarget);
    }
  }

  function getOption(option) {
    const optionMap = modelle.map((item) => {
      return item.metafields[option];
    });
    const filteredOptions = optionMap.filter((item) => {
      return item !== "";
    });
    if (filteredOptions.length === 0) return null;
    return Array.from(new Set(filteredOptions));
  }

  function sortModelle(modelle) {
    modelle.sort((a, b) => {
      return a.data.price - b.data.price;
    });
  }

  function sortOption(optionValues) {
    if (!optionValues) return;

    // Helper function to find the price for a given option value.
    // It finds the first variant in 'modelle' that has this value
    // in any of its option metafields (option1, option2, option3)
    // and returns its price.
    // WARNING: This assumes the price is determined solely by the option *value*,
    // regardless of which option *type* (option1/2/3) it belongs to.
    // It also uses the price from the *first* matching variant found, which might be arbitrary.
    const getPriceForValue = (value) => {
      const model = modelle.find(item =>
        (item.metafields.option1 === value ||
         item.metafields.option2 === value ||
         item.metafields.option3 === value) &&
        item.data // Ensure item.data exists
      );
      // Check if model and price exist, otherwise assign a high value for sorting
      const price = model && typeof model.data.price !== 'undefined' ? parseFloat(model.data.price) : Infinity;
      // If price is not a number, treat it as Infinity to sort it last
      return isNaN(price) ? Infinity : price;
    };

    optionValues.sort((a, b) => {
      const priceA = getPriceForValue(a);
      const priceB = getPriceForValue(b);

      // Primary sort: by price
      if (priceA !== priceB) {
        return priceA - priceB;
      }

      // Secondary sort (if prices are equal or both invalid/Infinity):
      // Attempt numeric sort first for stability if values look numeric
      const numA = parseInt(a);
      const numB = parseInt(b);
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }

      // Fallback to string locale comparison if not numeric
      return String(a).localeCompare(String(b));
    });
  }

  function changeSelectedOptionsByVariantUrl() {
    const urlObj = new URL(window.location.href);
    const variantId = urlObj.searchParams.get("variant");
    const findVariant = modelle.find((item) => {
      return item.data.id == variantId;
    });
    if (findVariant) {
      selectedOptions = [];
      for (const key in findVariant.metafields) {
        if (findVariant.metafields[key] !== "") {
          selectedOptions.push({
            property: key,
            value: findVariant.metafields[key],
          });
        }
      }
    }
  }

  function initSelectedOptions() {
    if (option1) {
      const firstOption = option1[0];
      selectedOptions.push({
        property: mainProductReverseMap[mainProductMap.option1],
        value: firstOption,
      });
    }
    if (option2) {
      const firstOption = option2[0];
      selectedOptions.push({
        property: mainProductReverseMap[mainProductMap.option2],
        value: firstOption,
      });
    }
    if (option3) {
      const firstOption = option3[0];
      selectedOptions.push({
        property: mainProductReverseMap[mainProductMap.option3],
        value: firstOption,
      });
    }
  }

  function checkURL() {
    const urlObj = new URL(window.location.href);
    const hasVariant = urlObj.searchParams.has("variant");
    return hasVariant;
  }

  function addLinePropertyToForm() {
    const form = document.querySelector(
      ".product__info-container .product-form form"
    );
    if(!form) return;
    const idInput = form.querySelector("input[name='id']");
    if(!idInput) return;
    idInput.value = selectedVariant.data.id;
    selectedOptions.forEach(function (item) {
      const input = document.createElement("input");
      input.setAttribute("we-input", "");
      input.type = "hidden";
      input.name = `properties[${mainProductMap[item.property]}]`;
      input.value = item.value;
      if(input.name === "properties[]") {
        return;
      }
      form.appendChild(input);
    });
  }

  function hideUnavailableOptions(targetElement) {
    const selectedOption1Value = selectedVariant.metafields.option1;
    const allAvailableOptions = modelle.filter((item) => {
      return item.metafields.option1 === selectedOption1Value;
    });

    const allAvailableOption2 = allAvailableOptions.map((item) => {
      return item.metafields.option2;
    });

    const allAvailableOption3 = allAvailableOptions
    .filter((item) => {
      return item.metafields.option2 === selectedVariant.metafields.option2;
    })
    .map((item) => {
      return item.metafields.option3;
    });

    const option2Select = document.querySelector(
      `${targetElement} .select__select[data-option="option2"]`
    );
    const option3Select = document.querySelector(
      `${targetElement} .select__select[data-option="option3"]`
    );

    if (option2Select) {
      const uniqueOptions = Array.from(new Set(allAvailableOption2));
      const options = option2Select.querySelectorAll("option");
      options.forEach((option) => {
        if (uniqueOptions.includes(option.value)) {
          option.classList.remove("we-hide");
        } else {
          option.classList.add("we-hide");
        }
      });
    }
    if (option3Select) {
      const uniqueOptions = Array.from(new Set(allAvailableOption3));
      const options = option3Select.querySelectorAll("option");
      options.forEach((option) => {
        if (uniqueOptions.includes(option.value)) {
          option.classList.remove("we-hide");
        } else {
          option.classList.add("we-hide");
        }
      });
    }
  }

  function renderOptions(targetSelector, extraClass) {
    const targetElement = document.querySelector(targetSelector);
    if (option1) {
      const element = createSelectOption(option1, "option1", extraClass);
      targetElement.appendChild(element);
    }
    if (option2) {
      const element = createSelectOption(option2, "option2", extraClass);
      targetElement.appendChild(element);
      const select = element.querySelector('select.select__select')
      if(!selectedVariant.metafields.option2) {
        select.selectedIndex = -1
      }
    }
    if (option3) {
      const element = createSelectOption(option3, "option3", extraClass);
      targetElement.appendChild(element);
      const select = element.querySelector('select.select__select')
      if(!selectedVariant.metafields.option3) {
        select.selectedIndex = -1
      }
    }
  }

  function optionsListeners(targetSelector, syncTarget) {
    const selects = document.querySelectorAll(targetSelector);
    selects.forEach(function (select) {
      select.addEventListener("change", function () {
        const selectedOption = select.options[select.selectedIndex];
        const option = selectedOption.getAttribute("data-option");
        const value = selectedOption.value;
        const property = mainProductReverseMap[mainProductMap[option]];
        const newSelect = {
          property: property,
          value: value,
        };
        weSelectedOption = option
        changeSelected(newSelect);
        const check = setSelectedVariant();
        updateURL();
        updatePrice();
        emitCustomEvent();
        if (check) {
          syncAllOptions();
        } else {
          syncData(syncTarget);
        }
        hideUnavailableOptions(
          `.we-custom-options .${generalOptionsSyncTarget}`
        );
        hideUnavailableOptions(
          `.we-custom-options .${floatedOptionsSyncTarget}`
        );
        updateLinePropertyToForm();
      });
    });
  }

  function updateLinePropertyToForm() {
    const form = document.querySelector(
      ".product__info-container .product-form form"
    );
    const idInput = form.querySelector("input[name='id']");
    idInput.value = selectedVariant.data.id;
    const allInputs = form.querySelectorAll("input[we-input]");
    allInputs.forEach((input) => {
      input.remove();
    });
    selectedOptions.forEach(function (item) {
      const input = document.createElement("input");
      input.setAttribute("we-input", "");
      input.type = "hidden";
      input.name = `properties[${mainProductMap[item.property]}]`;
      input.value = item.value;
      if(input.name === "properties[]") {
        return;
      }
      form.appendChild(input);
    });
  }

  function setSelectedVariant() {
    const findVariant = modelle.find((item) => {
      return selectedOptions.every((option) => {
        return item.metafields[option.property] === option.value;
      });
    });

    if (findVariant) {
      selectedVariant = findVariant;
      resetSelectedOptions();
    } else {
      const option1Value = selectedOptions.find((item) => {
        return item.property === "option1";
      });
      const option2Value = selectedOptions.find((item) => {
        return item.property === "option2";
      });
      let findVariant = null;
      findVariant = modelle.find((item) => {
        return item.metafields.option1 === option1Value.value && item.metafields.option2 === option2Value.value && item.metafields.option3
      });
      if(!findVariant) {
        findVariant = modelle.find((item) => {
          return item.metafields.option1 === option1Value.value && item.metafields.option2 === option2Value.value
        });
      }

      if(!findVariant) {
        findVariant = modelle.find((item) => {
          return item.metafields.option1 === option1Value.value && item.metafields.option2
        });
      }

      if(!findVariant) {
        findVariant = modelle.find((item) => {
          return item.metafields.option1 === option1Value.value
        });
      }
      selectedVariant = findVariant;
      resetSelectedOptions();
    }
    return true;
  }

  function resetSelectedOptions() {
    selectedOptions = [];
    selectedOptions.push({
      property: mainProductReverseMap[mainProductMap.option1],
      value: selectedVariant.metafields.option1,
    });
    if (option2 && selectedVariant.metafields.option2) {
      selectedOptions.push({
        property: mainProductReverseMap[mainProductMap.option2],
        value: selectedVariant.metafields.option2,
      });
    } else if(!selectedVariant.metafields.option2) {
      const select = document.querySelector('select.select__select[data-option="option2"]')
      if(select) {
        select.selectedIndex = -1;
      }
    }
    if (option3 && selectedVariant.metafields.option3) {
      selectedOptions.push({
        property: mainProductReverseMap[mainProductMap.option3],
        value: selectedVariant.metafields.option3,
      });
    } else if(!selectedVariant.metafields.option3) {
      const select = document.querySelector('select.select__select[data-option="option3"]')
      if(select) {
        select.selectedIndex = -1;
      }
    }
  }

  function emitCustomEvent() {
    const wesiteVariantChange = new CustomEvent("wesite-variant-change", {
      detail: {
        id: selectedVariant.data.id,
        price: selectedVariant.data.price,
        compare_at_price: selectedVariant.data.compare_at_price,
      },
    });
    document.dispatchEvent(wesiteVariantChange);
  }

  function updateURL() {
    const url = window.location.href;
    const baseUrl = new URL(url).origin + new URL(url).pathname;
    window.history.replaceState(
      {},
      "",
      `${baseUrl}?variant=${selectedVariant.data.id}`
    );
  }

  function updatePrice() {
    const prices = document.querySelectorAll(".price__regular .price-item");
    prices.forEach(function (price) {
      const normalPrice = selectedVariant.data.price / 100;
      price.innerText = formatPrice(normalPrice.toFixed(2)) + " €";
    });
    const leasingAngebotspreis = document.querySelectorAll("#full_price");
    leasingAngebotspreis.forEach(function (price) {
      const normalPrice = selectedVariant.data.price / 100;
      price.innerText = formatPrice(normalPrice.toFixed(2)) + " €";
    });
  }

  function changeSelected(newSelect) {
    selectedOptions = selectedOptions.map((item) => {
      return item.property === newSelect.property ? newSelect : item;
    });
  }

  function createSelectOption(option, optionKey, extraClass) {
    const divWrapper = document.createElement("div");
    divWrapper.classList.add("product-form__controls");
    divWrapper.classList.add(extraClass);
    const label = document.createElement("label");
    label.classList.add("product-form__group-name");
    label.innerText = mainProductMap[optionKey];
    divWrapper.appendChild(label);
    const innerWrapper = document.createElement("div");
    innerWrapper.classList.add("product-form__controls-group");
    const selectWrapper = document.createElement("div");
    selectWrapper.classList.add("select");
    const select = document.createElement("select");
    select.classList.add("select__select");
    select.setAttribute("data-option", optionKey);
    const svg = getSvg();
    selectWrapper.innerHTML = svg;
    selectWrapper.appendChild(select);

    option.forEach(function (option) {
      const optionElement = document.createElement("option");
      optionElement.value = option;
      optionElement.text = option;
      optionElement.setAttribute("data-option", optionKey);
      select.appendChild(optionElement);
    });
    innerWrapper.appendChild(selectWrapper);
    divWrapper.appendChild(innerWrapper);
    return divWrapper;
  }

  function getSvg() {
    return `
      <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 20 20" class="icon icon-caret">
          <path d="M9.99996 11.6667L6.66663 8.33333H13.3333L9.99996 11.6667Z" fill="currentColor"></path>
      </svg>
      `;
  }

  function syncData(target) {
    selectedOptions.forEach(function (option) {
      const select = document.querySelector(
        `.we-custom-options .${target} .select__select[data-option="${option.property}"]`
      );
      if (!select) return;
      select.value = option.value;
    });
  }

  function syncAllOptions() {
    syncData(generalOptionsSyncTarget);
    // syncData(floatedOptionsSyncTarget);
  }

  function initFloatedFormListeners() {
    document.addEventListener("floatedFormLoaded", () => {
      renderOptions(
        ".floated-form .we-custom-options",
        floatedOptionsSyncTarget
      );
      hideUnavailableOptions(`.we-custom-options .${floatedOptionsSyncTarget}`);
      optionsListeners(
        ".floated-form .we-custom-options .select__select",
        generalOptionsSyncTarget
      );
      if (urlHasVariant) {
        syncData(floatedOptionsSyncTarget);
      }
    });
  }

  function formatPrice(price) {
    let parts = price.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if (parts[1] !== undefined) {
      parts[1] = `,${parts[1]}`;
    }
    return parts.join("");
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  main();
});
